module.exports = __webpack_public_path__ + "static/media/grandOpeningNewBurst.cd4aa93e.svg";